module.exports = __webpack_public_path__ + "static/dash-2-6ba8a52edf040bbbcb10fd75cd3ec527.png";